/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui
 * @description Navigation main menu
 * @section 4.5
 *
 * @evaluation good
 * @category simple ui
 */
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
interface Props {
  open?: boolean;
}
const useStyles = makeStyles((theme) => ({
  button: {
    padding: 0,
    minWidth: "auto",
  },
  icon: {
    width: "1.8em",
    height: "1.2em",
    position: "relative",
    transition: ".5s ease-in-out",
    transform: "rotate(0deg)",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& span": {
      display: "block",
      position: "absolute",
      opacity: 1,
      left: 0,
      height: "0.081em",
      width: "100%",
      background: "#111111",
      transform: "rotate(0deg)",
      transition: ".25s ease-in-out",
      transformOrigin: "left center",
      "&:nth-child(1)": {
        top: "0px",
      },
      "&:nth-child(2)": {
        top: "0.3733333333em",
      },
      "&:nth-child(3)": {
        top: "0.7466666666em",
      },
      "&:nth-child(4)": {
        top: "1.1199999999em",
      },
    },
  },
  open: {
    "& span": {
      "&:nth-child(1), &:nth-child(4)": {
        width: "0px",
        opacity: 0,
      },
      "&:nth-child(2)": {
        top: "-0.1333333333em ",
        left: "0.2636038969em",
        transform: "rotate(45deg)",
        width: "1.8em",
        height: "0.1em",
      },
      "&:nth-child(3)": {
        top: "1.1394588728em",
        left: "0.2636038969em",
        transform: "rotate(-45deg)",
        width: "1.8em",
        height: "0.1em",
      },
    },
  },
}));
export default function HamburgerMenu(props: Props) {
  const { open } = props;
  const classes = useStyles();
  return (
    <div className={clsx(classes.icon, open && classes.open)}>
      <span />
      <span />
      <span />
      <span />
    </div>
  );
}
